import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoNotificationMixin from './KendoNotificationMixin'

export default {
    name: 'kendo-notification',
    mixins: [ KendoNotificationMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        return h('span')
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-popups-vue-wrapper/src/KendoNotification/index.js